import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HEADER_STATES } from '../../../shared/header/header.helper';
import { APP_COLORS } from '../../../../global-styles';
import { SneCoachabilityBase } from '../sne-coachability.base';
import { SneAnswerService } from '../../../services/sne-answer.service';


@Component({
  selector: 'ets-coachability-interstitial',
  templateUrl: './coachability-interstitial.component.html',
  styleUrls: ['./coachability-interstitial.component.scss']
})
export class CoachabilityInterstitialComponent extends SneCoachabilityBase implements OnInit {

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  headerState = HEADER_STATES.BACK;
  APP_COLORS = APP_COLORS;
  endInterstitial = false;

  ngOnInit() {
    // Get the route params to determine if it's the end interstitial
    this.route.params.subscribe(params => {
      const { questionNum, section } = params;
      this.endInterstitial = questionNum === 'end';
    });
    this.processParams();
  }

}
